import { useTheme } from "@mui/material";
import { useTimeout } from "ahooks";

import { platformApi } from "@/app/platform";

type UseSwipeableDrawerAutoFocusParams = {
  isInSwipeableDrawer: boolean;
  onFocus: () => void;
};

// Hack to enable correct drawer positioning with autoFocus on Android.
// This issue is that autoFocus happens during the drawer open animation
// which causes incorrect drawer positioning(scrolled outside of the viewport)
// Works fine for IOS, thus only applying for Android
function useSwipeableDrawerAutoFocus({
  isInSwipeableDrawer,
  onFocus,
}: UseSwipeableDrawerAutoFocusParams) {
  const theme = useTheme();
  const shouldUseNativeAutoFocus =
    !isInSwipeableDrawer || platformApi.deviceType !== "Android";

  useTimeout(() => {
    if (shouldUseNativeAutoFocus) return;

    onFocus();
  }, theme.transitions.duration.enteringScreen / 2);

  return {
    shouldUseNativeAutoFocus,
  };
}

type UseAutoFocusParams = {
  inputRef: React.RefObject<HTMLInputElement | null>;
  isInSwipeableDrawer: boolean;
  enabled?: boolean;
};

export function useInputAutoFocus({
  inputRef,
  enabled = true,
  isInSwipeableDrawer,
}: UseAutoFocusParams) {
  const { shouldUseNativeAutoFocus } = useSwipeableDrawerAutoFocus({
    isInSwipeableDrawer,
    onFocus: () => {
      if (!enabled) return;

      inputRef.current?.focus();
    },
  });

  return shouldUseNativeAutoFocus && enabled;
}
